import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6afc435f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-max-w-[800px] tw-flex-col tw-justify-center tw-items-start tw-gap-[25px] tw-self-stretch tw-px-0 tw-py-[25px] tw-rounded-[6px] mainWrapper" }
const _hoisted_2 = { class: "tw-flex tw-gap-[10px] tw-items-center titleWrapper" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[145%] title" }
const _hoisted_4 = { class: "descriptionWrapper" }
const _hoisted_5 = { class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal] description" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(" "), -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-h-[1px] tw-w-full tw-bg-[#EFF0F1]" }, null, -1))

import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { MODAL_NAME } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardQuestion',
  props: {
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: "",
  },
  hasWhy: {
    type: Boolean,
    default: false,
  },
  customPaddingX: {
    type: String,
    default: "25px",
  },
},
  setup(__props) {



const openModalMoreInfor = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_MORE_INFO,
    properties: {
      isMoreInfoModal: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({
        paddingLeft: __props.customPaddingX,
        paddingRight: __props.customPaddingX,
      }),
      class: "tw-flex tw-flex-col tw-gap-[10px] main"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.description), 1),
        _hoisted_6,
        (__props.hasWhy)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal] tw-cursor-pointer hover:tw-opacity-80",
              onClick: openModalMoreInfor
            }, _toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-modal-wrapper-description-why-link-1",
            )), 1))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _hoisted_7,
    _createElementVNode("div", {
      style: _normalizeStyle({
        paddingLeft: __props.customPaddingX,
        paddingRight: __props.customPaddingX,
      }),
      class: "tw-w-full questionsWrapper"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ]))
}
}

})